import {useQuery} from 'react-query'
import {Get} from '../../../../../setup'
import {
    initialValuesNaturalReferencingAcquisition, initialValuesNaturalReferencingAudienceView,
    initialValuesNaturalReferencingContent, initialValuesNaturalReferencingViewByGeography,
    NaturalReferencingDataState,
} from '../../../../@types'
import {LoadingState, PeriodType} from '../../../../../global'
import {useMemo, useState} from 'react'

type Props = {
    period: PeriodType
}

const SEO = process.env.REACT_APP_STATISTICS_SEO || 'statistics-seo'

export const useNaturalReferencingData = ({period}: Props) => {

    const [loading, setLoading] = useState<LoadingState>('idle')
    const [error, setError] = useState<string | null>(null)
    const [data, setData] = useState({
        acquisition: initialValuesNaturalReferencingAcquisition,
        content: initialValuesNaturalReferencingContent,
        audienceView: initialValuesNaturalReferencingAudienceView,
        viewByGeography: initialValuesNaturalReferencingViewByGeography,
    })

    const {refetch} = useQuery(
        ['NATURAL_REFERENCING_SEO', period],
        () => Get<NaturalReferencingDataState>({endpoint: SEO, period}),
        {
            onSuccess: (data) => {
                setLoading('fulfilled')
                const {
                    vueAudience,
                    acquisition,
                    contenu,
                    vueParGeographie,
                } = data

                setData({
                    audienceView: vueAudience,
                    acquisition: acquisition,
                    viewByGeography: vueParGeographie,
                    content: contenu,
                })
                setError(null)
            },
            onError: (err: any) => {
                setLoading('rejected')
                setError(err.message || 'Une erreur est survenue')
            },
        },
    )

    const contextValue = useMemo(() => ({
        acquisition: data.acquisition,
        content: data.content,
        audienceView: data.audienceView,
        viewByGeography: data.viewByGeography,
        period,
    }), [data])

    return {data: contextValue, refetch, loading, error}
}